import React, { FC, useLayoutEffect } from 'react';
import PreferencesForm from './PreferencesForm';
import { SocialTitleWrapper } from '../AuthModal.styles';
import { Heading1 } from '@blueprint/ui';
import triggerTracking from '@blueprint/tracking';
import { PreferencesProps } from './Preferences.types';

const socialRegTitle =
    'Get expert advice, guidance and inspiration straight to your inbox.';

const Preferences: FC<PreferencesProps> = ({
    close,
    actionAfterAuth,
    isSSOPhaseTwoFeatureEnabled
}) => {
    const socialHeader = React.useRef<HTMLHeadingElement>(null);

    useLayoutEffect(() => {
        if (socialHeader?.current) {
            socialHeader?.current.focus();
        }

        triggerTracking({
            event: 'GAEvent',
            eventCategory: 'registration',
            eventAction: 'form shown',
            eventLabel: `${actionAfterAuth?.eventLabel}_step_2`
        });
    }, []);

    return (
        <>
            <SocialTitleWrapper data-testid="social-login-heading-wrapper">
                <Heading1
                    data-testid="social-login-heading"
                    size="5"
                    tabIndex={-1}
                    ref={socialHeader}
                >
                    {socialRegTitle}
                </Heading1>
            </SocialTitleWrapper>
            <PreferencesForm
                close={close}
                actionAfterAuth={actionAfterAuth}
                isSSOPhaseTwoFeatureEnabled={isSSOPhaseTwoFeatureEnabled}
            />
        </>
    );
};

export default Preferences;
